<template>
    <div>
      <el-tabs v-model="activeName" :stretch="true">
        <el-tab-pane label="输入身份证号码" name="first">
          <div>
            <cell label="姓名" placeholder="请输入姓名" v-model="form.name"></cell>
            <cell label="手机号" v-model="form.phone" placeholder="请输入手机号"></cell>
            <cell label="身份证号" v-model="form.idCardNumber" @input="input" placeholder="请输入身份证号"></cell>
            <div @click="showPicker('sex')">
              <cell label="性别" :disabled="true" :value="form.sex" placeholder="请输入性别"></cell>
            </div>
            <div @click="showPicker('date')">
              <cell label="出生日期" :disabled="true" :value="form.birthDate" placeholder="请输入出生日期"></cell>
            </div>
            <div @click="showPicker('nationItems')">
              <cell label="民族" :disabled="true" :value="form.nation" placeholder="请输入民族"></cell>
            </div>
            <cell label="家庭住址" v-model="form.address" placeholder="请输入家庭住址"></cell>
<!--            <div @click="showPicker('cardType')">-->
<!--              <cell label="卡类型" :disabled="true" :value="form.cardType" placeholder="请输入卡类型"></cell>-->
<!--            </div>-->
            <cell label="就诊卡号" v-model="form.cardNumber" placeholder="请输入就诊卡号，没有可不填"></cell>
            <div class="vuePicker">
              <VuePicker :data="pickData" @confirm="confirm" :showToolbar="true" :maskClick="true" :visible.sync="pickerVisible"/>
            </div>
          </div>
          <div style="text-align: center">
            <el-button type="primary" class="addButton" @click="addCard">立即注册</el-button>
          </div>
          <div style="text-align: center;font-size: .28rem;color: #409eff;height: .6rem;line-height: .6rem;margin-top: .4rem" @click="yjsq">
            《已有健康卡，一键授权》
          </div>
        </el-tab-pane>
        <el-tab-pane label="上传身份证照片" name="second">
          <div>
            <div class="upload">
              <div class="uploadImg">
                <input style="position: absolute;width: 5rem;height:2.8rem;opacity:0;z-index: 100" type="file" accept="image/*" @change="uploadIdCard($event)"/>
                <img src="static/img/uploadIdCard.png" ref="uploadImg"/>
                <i class="el-icon-circle-close errorIcon" v-if="showError"></i>
                <div class="uploadError" v-if="showError">
                  <span style="padding-left: .6rem">点击重新上传身份证正面照</span>
                </div>
              </div>
            </div>
            <div class="uploadText">
              <div>说明：</div>
              <div>1.拍照时请将身份证摆正</div>
              <div>2.请上传您的身份证正面照</div>
              <div>3.如果识别错误，请重新拍照</div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
  import cell from '../common/Cell'
  import areaCode from '../../utils/area'
  import VuePicker from 'vue-pickers'
  import {sex,nationItems,cardType} from '../../utils/pickerData'
  import {registerByBaseInfo,byIdCardImage,GetBaseInfo_ByHealthCode} from '../../api/index'
  let year=[]
  let month=[]
  let day=[]
  for (let i = 2021; i > 1840; i--) {
    year.push({label:i,value:i})
  }
  for (let i = 1; i <= 12; i++) {
    month.push({label:i,value:i})
  }
  for (let i = 1; i <= 31; i++) {
    day.push({label:i,value:i})
  }
    export default {
      data(){
        return{
          activeName: 'first',
          pickData:[],
          pickType:'',
          pickerVisible: false,
          birthDate:{
            year:'',
            month:'',
            day:'',
          },
          form:{
            name:'',
            phone:'',
            idCardNumber:'',
            sex:'女',
            birthDate:'',
            nation:'汉族',
            address:'',
            cardType:'就诊卡号',
            cardNumber:''
          },
          showError:false,
        }
      },
      components:{
        cell,
        VuePicker
      },
      created() {
        //修改标题
        document.title = '电子健康卡注册'
        //获取健康卡wechatCode
        if(!this.getUrlSearch('wechatCode')){
          if(this.getUrlSearch('healthCode')){
            window.location.replace('https://health.tengmed.com/open/getUserCode?redirect_uri='+encodeURIComponent(location.protocol + '//' + location.host +'/#/addHealthCard?healthCode='+this.getUrlSearch('healthCode')))
          }else {
            window.location.replace('https://health.tengmed.com/open/getUserCode?redirect_uri='+encodeURIComponent(location.protocol + '//' + location.host +'/#/addHealthCard'))
          }
          return
        }
        //一键授权时返回参数
        if(this.getUrlSearch('healthCode')&&this.getUrlSearch('wechatCode')){
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          GetBaseInfo_ByHealthCode({
            healthCode:this.getUrlSearch('healthCode')
          }).then(res=>{
            if(res.IsSuccess){
              if(res.Data.errMsg){
                this.$message({
                  message: '授权码过期，请重新选择！',
                  type: 'error',
                  duration:3000,
                  center:true,
                  offset:200
                });
              }
              this.form.name = res.Data.name
              this.form.phone = res.Data.phone1
              this.form.idCardNumber = res.Data.idCard
              this.form.sex = res.Data.gender
              this.form.birthDate = res.Data.birthday
              this.form.nation = res.Data.nation
              this.form.address = res.Data.address
            }else {
              this.$message({
                message: res.Msg,
                type: 'error',
                duration:3000,
                center:true,
                offset:200
              });
            }
            loading.close();
          })
        }
        if(this.$storage.get('clinic_patient_name')){
          this.form.name = this.$storage.get('clinic_patient_name')
        }
        if(this.$storage.get('clinic_num')){
          this.form.cardNumber = this.$storage.get('clinic_num')
        }
      },
      methods:{
        //下拉列表切换值
        confirm (res) {
          if(this.pickType == 'sex'){
            this.form.sex = res[0].value
          }else if(this.pickType=='nationItems'){
            this.form.nation = res[0].value
          }else if(this.pickType=='date'){
            if(res[0]){
              this.birthDate.year = res[0].value
            }
            if(res[1]){
              this.birthDate.month = res[1].value
            }
            if(res[2]){
              this.birthDate.day = res[2].value
            }
            this.form.birthDate = this.birthDate.year+'-'+this.birthDate.month+'-'+this.birthDate.day
          }else if(this.pickType=='cardType'){
            this.form.cardType = res[0].value
          }
        },
        //下拉列表赋值
        showPicker(type){
          if(type=='sex'){
            this.pickData = [sex]
          }else if(type=='nationItems'){
            this.pickData = [nationItems]
          }else if(type=='date'){
            this.pickData = [year,month,day]
          }else if(type=='cardType'){
            this.pickData = [cardType]
          }
          this.pickType = type
          this.pickerVisible = true
        },
        input(e){
          if(e.length==18){
            this.form.birthDate = e.slice(6,10)+'-'+e.slice(10,12)+'-'+e.slice(12,14)
            this.form.sex = e.slice(16,17)%2==0?'女':'男'
            this.form.address = areaCode.province_list[e.slice(0,2)+'0000']+areaCode.city_list[e.slice(0,4)+'00']+areaCode.county_list[e.slice(0,6)]
          }
        },
        //新增按钮
        addCard(){
          if(!this.form.name){
            this.$message({
              message: '名字输入有误！',
              type: 'error',
              duration:3000,
              center:true,
              offset:200
            });
            return
          }
          //身份证验证
          if(!(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.form.idCardNumber))){
            this.$message({
              message: '身份证号输入有误！',
              type: 'error',
              duration:3000,
              center:true,
              offset:200
            });
            return
          }
          //手机号验证
          if(!(/^1[3456789]\d{9}$/.test(this.form.phone))){
            this.$message({
              message: '手机号输入有误！',
              type: 'error',
              duration:3000,
              center:true,
              offset:200
            });
            return
          }
          registerByBaseInfo({
            wechatCode: this.getUrlSearch('wechatCode'),
            name: this.form.name,
            gender: this.form.sex,
            nation: this.form.nation,
            birthday: this.form.birthDate,
            idCard: this.form.idCardNumber,
            idType: '01',
            phone1: this.form.phone,
            address: this.form.address,
            openId:this.$storage.get('openid'),
            unionid:this.$storage.get('unionid'),
            patid:this.form.cardNumber
          }).then(res=>{
            if(res.IsSuccess){
              this.$message({
                message: '注册成功！',
                type: 'success',
                duration:3000,
                center:true,
                offset:200
              });
              this.$router.push({path:'/personManage'})
            }else {
              this.$message({
                message: res.Msg,
                type: 'error',
                duration:3000,
                center:true,
                offset:200
              });
            }
          })
        },
        //上传身份证 返回base64
        uploadIdCard (event) {
          let _this = this
          let file = event.target.files[0]
          let reader = new FileReader()
          //上传时间太长 增加loading
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          // 读取图片
          if(file == null || file == ''){
            _this.showError = true
            _this.$message({
              message: '上传失败，请重试！',
              type: 'error',
              duration:3000,
              center:true,
              offset:200
            });
            loading.close();
            return
          }
          reader.readAsDataURL(file)
          // 读取完毕后的操作
          reader.onloadend  = function(e) {
            //将上传的图片替换当前图片
            _this.$refs.uploadImg.src = reader.result
            // reader.result就是图片的base64字符串
            let img = new Image();
            img.src = reader.result;
            //图片压缩
            img.onload = function(){
              let canvas = document.createElement("canvas");
              let ctx = canvas.getContext('2d');
              canvas.width = 300;
              canvas.height = 200;
              //铺底色
              ctx.fillStyle = "#fff";
              ctx.fillRect(0, 0, canvas.width, canvas.height);
              ctx.drawImage(img, 0, 0, 300, 200);
              //进行最小压缩
              let compressImg = canvas.toDataURL('image/jpeg', 1);
              byIdCardImage({
                imageContent:encodeURIComponent(compressImg.split(',')[1])
              }).then(res=>{
                loading.close();
                if(!res.Data.id){
                  _this.showError = true
                  _this.$message({
                    message: '识别失败，请重试！',
                    type: 'error',
                    duration:3000,
                    center:true,
                    offset:200
                  });
                }else {
                  _this.activeName = 'first'
                  _this.form.name = res.Data.name
                  _this.form.idCardNumber = res.Data.id
                  _this.form.sex = res.Data.gender
                  _this.form.birthDate = res.Data.birth.replace(/\//g, '-')
                  _this.form.nation = res.Data.nation
                  _this.form.address = res.Data.address
                }
              })
            }
          }
        },
        yjsq(){
          window.location.replace('https://health.tengmed.com/open/getHealthCardList?redirect_uri='+encodeURIComponent(location.protocol + '//' + location.host +'/#/addHealthCard?wechatCode='+this.getUrlSearch('wechatCode')))
        },
        //获取地址栏上的参数
        getUrlSearch(name) {
          // 未传参，返回空
          if (!name) return null;
          // 查询参数：先通过search取值，如果取不到就通过hash来取
          var after = window.location.search;
          after = after.substr(1) || window.location.hash.split('?')[1];
          // 地址栏URL没有查询参数，返回空
          if (!after) return null;
          // 如果查询参数中没有"name"，返回空
          if (after.indexOf(name) === -1) return null;
          var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
          // 当地址栏参数存在中文时，需要解码，不然会乱码
          var r = decodeURI(after).match(reg);
          // 如果url中"name"没有值，返回空
          if (!r) return null;
          return r[2];
        },
      }
    }
</script>

<style scoped>
  .addButton{
    width: 4rem;
  }
  .upload{
    width: 100%;
    height: 3.5rem;
    display: flex;
    align-items: center;
  }

  .uploadImg {
    width: 5rem;
    height: 2.8rem;
    margin: 0 auto;
    border: 1px #cccccc solid;
    border-radius: .2rem;
    position: relative;
  }
  .uploadImg img {
    width: 100%;
    height: 100%;
    border-radius: .2rem;
  }
  .errorIcon{
    font-size: 0.4rem;
    position: absolute;
    left: .1rem;
    bottom: .1rem;
    color: #ffffff;
    z-index: 99;
  }
  .uploadError{
    position: absolute;
    font-size: .24rem;
    top:2.2rem;
    background-color: rgba(244,0,0, 0.5);
    line-height: .59rem;
    width: 100%;
    height: .6rem;
    color: #fff;
    border-bottom-left-radius: .2rem;
    border-bottom-right-radius: .2rem;
  }
  .uploadText{
    font-size: .28rem;
    margin-left: .4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/addHealthCard.vue